import React from "react"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import Dropdown from "aldoo-ra/Dropdown"
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline"

const PaginationControls = ({
  rowsPerPage,
  onRowsPerPageChange,
  startIndex,
  endIndex,
  totalItems,
  onPageChange,
  page,
  totalPages,
}) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-center mt-4 gap-4 px-4 pb-4">
      {/* Mobile: Top row with dropdown on left, buttons on right */}
      <div className="flex md:hidden w-full justify-between items-center">
        {/* Rows per page dropdown - left side on mobile */}
        <div className="flex flex-row items-center">
          <Dropdown
            menuPosition="top"
            className="w-[100px]"
            value={rowsPerPage}
            options={[10, 20, 50, 100]}
            onChange={onRowsPerPageChange}
          />
        </div>

        {/* Navigation buttons - right side on mobile */}
        <div className="flex flex-row gap-2">
          {/* Previous page button */}
          <Button
            onClick={() => onPageChange(Math.max(page - 1, 1))}
            disabled={page === 1}
            variant="admin_viewer_controls"
            className="font-medium"
          >
            <ArrowLeftIcon className="w-5 h-5" />
          </Button>
          {/* Next page button */}
          <Button
            onClick={() => onPageChange(Math.min(page + 1, totalPages))}
            disabled={page === totalPages}
            variant="admin_viewer_controls"
            className="font-medium"
          >
            <ArrowRightIcon className="w-5 h-5" />
          </Button>
        </div>
      </div>

      {/* Desktop layout */}
      <div className="hidden md:flex flex-row items-center w-[150px]">
        <Dropdown
          menuPosition="top"
          className="w-[150px]"
          value={rowsPerPage}
          options={[10, 20, 50, 100]}
          onChange={onRowsPerPageChange}
        />
      </div>

      {/* Items count - center on desktop, bottom on mobile */}
      <Typography className="text-admin_text mt-2 md:mt-0">
        {`${(startIndex + 1).toLocaleString()}–${endIndex.toLocaleString()} of ${totalItems.toLocaleString()}`}
      </Typography>

      {/* Navigation buttons - desktop only (hidden on mobile since they're in top row) */}
      <div className="hidden md:flex flex-row gap-2">
        {/* Previous page button */}
        <Button
          onClick={() => onPageChange(Math.max(page - 1, 1))}
          disabled={page === 1}
          variant="admin_viewer_controls"
          className="font-medium"
        >
          <ArrowLeftIcon className="w-5 h-5" />
        </Button>
        {/* Next page button */}
        <Button
          onClick={() => onPageChange(Math.min(page + 1, totalPages))}
          disabled={page === totalPages}
          variant="admin_viewer_controls"
          className="font-medium"
        >
          <ArrowRightIcon className="w-5 h-5" />
        </Button>
      </div>
    </div>
  )
}

export default PaginationControls
